import { ethers } from 'ethers';

export default {
  init,
  load,
  isAddress,
};

function init() {}

function load(done) {
  done && done();
}

function isAddress(addr: string) {
  let ret = false;
  try {
    ethers.utils.getAddress(addr);
    ret = true;
  } catch (e) {
    // noop
  }
  return ret;
}
